import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';

import { setModoTela, initForm } from './processoLogisticaActions';
import Camera from '../common/camera/camera';
import consts from '../consts';

class ProcessoLogisticaForm extends Component {

	state = {
		eventoTirarFoto: null
	};

    componentWillMount() {

		let initSeletorArquivo = () => {
			const fileSelectorArquivo = document.createElement('input');
			fileSelectorArquivo.setAttribute('type', 'file');
			fileSelectorArquivo.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {


						let lista = (this.props.formularioValues.arquivos || []).map(item => item);
						lista.push({
							arquivo_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							arquivos: lista
						});

						initSeletorArquivo();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorArquivo = fileSelectorArquivo;
		};

		initSeletorArquivo();

    }

    render() {

		if (this.state.eventoTirarFoto) {
			return <Camera eventoFoto={this.state.eventoTirarFoto} />
		}

		let readOnly = this.props.excluir ? 'readOnly' : '';

		let tipo = this.props.listaTipo.filter(item => item.id == this.props.formularioValues.id_tipo)[0] || {};

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='data_realizacao'
								component={LabelAndInputDate}
								label='Data' placeholder='Informe a data'
								cols='12 4 4 4'
								readOnly={'readOnly'} />
	
							<Field
								name='id_unidade'
								component={Select}
								options={this.props.listaUnidade}
								label='Unidade'
								cols='12 12 12 12'
								placeholder='Selecione o unidade'
								readOnly={this.props.formularioValues.id_unidade ? 'readOnly' : readOnly} />

							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo'
								cols='12 12 12 12'
								placeholder='Selecione o tipo'
								readOnly={this.props.formularioValues.id_tipo ? 'readOnly' : readOnly} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe a observação'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{this.props.formularioValues.nome_usuario &&
							<Field
								name='nome_usuario'
								component={LabelAndInput}
								label='Usuário' placeholder='Informe o usuário'
								cols='12 12 12 12'
								readOnly={'readOnly'} />}
						
						</Row>

						<Row>
							<Grid cols='12 12 12 12'>

								<Row style={{ paddingBottom: 16 }}>
									<Grid cols='12 12 12 12'>
										<label>Anexos</label>
									</Grid>
									{(this.props.formularioValues.arquivos || []).map(arquivo => (
										<div style={{ display: 'flex', flexDirection: 'column' }}>
											<span class="btn btn-outline-primary fileinput-button dz-clickable">
												<img src={arquivo.arquivo_base64 ? arquivo.arquivo_base64 : (arquivo.arquivo ? `${consts.URL}/${arquivo.arquivo}` : pdfAdd)} style={{ height: 30 }} />
											</span>
											{console.log(arquivo)}
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
												<button
													type='button'
													class='btn btn-flat btn-outline-primary'
													style={{ width: '48%' }}
													disabled={arquivo.arquivo_base64 ?true : false}
													onClick={() => {
														window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
													}}>
													<i class='fas fa-download'></i>
												</button>

												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: '48%' }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															arquivos: this.props.formularioValues.arquivos.filter(item => item != arquivo)
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										</div>
									))}
									{!readOnly ? (
										<a class={`btn btn-app bg-success`}
											onClick={() => {
												this.setState({
													...this.state,
													eventoTirarFoto: (result) => {

														let lista = (this.props.formularioValues.arquivos || []).map(item => item);
														lista.push({
															arquivo_base64: result
														});

														this.props.initForm({
															...this.props.formularioValues,
															arquivos: lista
														});

														this.setState({
															...this.state,
															eventoTirarFoto: null
														});
													}
												});
											}}>
											<i class='fas fa-camera'></i> Câmera
										</a>
									) : null}
								</Row>

							</Grid>
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

ProcessoLogisticaForm = reduxForm({form: 'processoLogisticaForm', destroyOnUnmount: false})(ProcessoLogisticaForm);
const mapStateToProps = state => ({
	sessao: state.auth.processoLogistica,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('processoLogisticaForm')(state),
	registro: state.processoLogistica.registro,
	listaUnidade: state.processoLogistica.listaUnidade.filter(item => !item.valor.includes('DIRETA')).filter(item => !item.valor.includes('DIRETA')).filter(item => {
		if (state.auth.usuarioCarregado && state.auth.usuarioCarregado.id_unidade) {
			return item.id == state.auth.usuarioCarregado.id_unidade;
		} else {
			return true;
		}
	}),
    listaTipo: state.processoLogistica.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ProcessoLogisticaForm);
